import humanizeString from 'humanize-string'
import React, { FC } from 'react'

import { HomeOperationsReadinessStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { FiltersSharedProps } from '@avantstay/backoffice-core'

import { RadioBasedField } from '@new/__global/components/Filters'

interface OperationStatusFilterProps extends FiltersSharedProps {
  initialValue?: string
  onChange: (value?: string) => void
}

export const OperationStatusFilter: FC<OperationStatusFilterProps> = ({
  initialValue,
  onChange,
}) => {
  const statusFilterOptions = Object.values(HomeOperationsReadinessStatus).map(statusOption => ({
    id: statusOption,
    title: humanizeString(statusOption),
    value: statusOption,
  }))

  return (
    <RadioBasedField
      radioGroupId="operationReadinessStatus"
      options={statusFilterOptions}
      onChange={onChange}
      initialValue={initialValue}
      title="Status"
    />
  )
}
